import { useTheme } from '@mui/material/styles';
import styled from 'styled-components';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { Grafico } from '../Home.styles';
import { chartSeverityColors, chartSubtitleColor, chartTitleColor } from './chartColors';

const GaugeArea = styled.div`
  width: 100%;
  height: 130px;

  .recharts-wrapper,
  .recharts-surface {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const AverageDaysValueChart = ({ averageDaysValue }: { averageDaysValue: number }) => {
  const { palette } = useTheme();

  const averageDaysData = [{ value: 3 }, { value: 3 }, { value: 9 }];

  const RADIAN = Math.PI / 180;

  const cx = 185;
  const cy = 185;
  const iR = 90;
  const oR = 180;

  const needle = (
    value: number,
    averageDays: any[],
    cx: number,
    cy: number,
    iR: number,
    oR: number,
    COLORS: string | any[],
  ) => {
    let total = 0;

    averageDaysData.forEach(v => {
      total += v.value;
    });

    const ang = 180.0 * (1 - value / total);
    const length = (iR + 2 * oR) / 3;
    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);
    const r = 5;
    const x0 = cx + 5;
    const y0 = cy + 5;
    const xba = x0 + r * sin;
    const yba = y0 - r * cos;
    const xbb = x0 - r * sin;
    const ybb = y0 + r * cos;
    const xp = x0 + length * cos;
    const yp = y0 + length * sin;

    return [
      <circle key={1} cx={x0} cy={y0} r={r} fill={palette.text.primary} stroke="none" />,
      <path
        key={2}
        d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
        stroke="#none"
        fill={palette.text.primary}
      />,
    ];
  };

  return (
    <Grafico>
      <div style={{ width: '100%' }}>
        <p style={{ color: chartTitleColor, fontSize: 16, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
          Média de dias por documento
        </p>
        <span style={{ color: chartSubtitleColor, fontSize: 13, fontWeight: 400 }}>
          Duração média dos documentos (dias)
        </span>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
          <GaugeArea>
            <PieChart width={380} height={200}>
              <Pie
                dataKey="value"
                startAngle={180}
                endAngle={0}
                data={averageDaysData}
                cx={cx}
                cy={cy}
                innerRadius={iR}
                outerRadius={oR}
                stroke="none"
                // label={({ name, value }) => `${name}: ${value}`}
              >
                {averageDaysData?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={chartSeverityColors[index % chartSeverityColors.length]} />
                ))}
              </Pie>
              {needle(averageDaysValue, averageDaysData, cx, cy, iR, oR, '')}
              <Tooltip />
            </PieChart>
          </GaugeArea>
          <h3 style={{ margin: '8px 0 0' }}>{`Média: ${averageDaysValue}`}</h3>
        </div>
      </div>
    </Grafico>
  );
};
